<template>
  <OnClickOutside @trigger="toggleOutside">
    <section class="grid mb-2 align-items-center" @click="recordLocation">
      <div class="col flex align-items-center">
        <slot name="left"></slot>
        <slot :toggle="toggle">DEFAULT</slot>
      </div>
      <div v-if="slots.right">
        <slot name="right"></slot>
      </div>
      <slot name="right-raw"></slot>

      <transition name="vertical-slide">
        <div v-if="isOpen" class="col-12">
          <slot name="expand" :toggle="toggle" :is-open="isOpen">
            YOU FORGOT TO FILL ME OUT
          </slot>
        </div>
      </transition>
    </section>
  </OnClickOutside>
</template>

<script setup lang="ts">
import { ref, useSlots } from "vue";
import { OnClickOutside } from "@vueuse/components";

const isOpen = ref(false);
const toggle = () => {
  if (isOpen.value === true) {
    scrollBack();
  }
  isOpen.value = !isOpen.value;
};

const recordedScrollY = ref(0);

const slots = useSlots();

function toggleOutside(e: { target: HTMLElement }) {
  // ignores clicks to browser scrollbar
  if (e.target === document.documentElement) return;

  // ignore clicks on itemsPerPage select dropdown
  if (e.target.className.includes?.("p-dropdown-item")) return;

  isOpen.value = false;
}

const scrollBack = () => {
  if (recordedScrollY.value !== 0) {
    window.scrollTo(0, recordedScrollY.value);
  }
};

const recordLocation = () => {
  const equipmentSecName = "col-12";
  const SectionEquipmentNumber = 2;
  const FirstEquipment = 0;
  // Checking for Equipment Section to see if any is open
  const mainElement = document
    .getElementById("splitter-left")
    ?.querySelector("section")
    ?.querySelector("fieldset");
  if (mainElement) {
    if (
      (mainElement.getElementsByClassName(equipmentSecName) as HTMLCollection)[
        SectionEquipmentNumber
      ]
    ) {
      recordedScrollY.value =
        window.scrollY -
        mainElement.getElementsByClassName(equipmentSecName)[FirstEquipment]
          ?.clientHeight;
    } else {
      recordedScrollY.value = window.scrollY;
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-row {
  margin-bottom: 1em;
  display: grid;
  align-items: center;
  grid-template-columns: minmax(50px, 1fr) minmax(50px, min-content);
  gap: 1em;
  .expander {
    grid-column: 1/-1;
    grid-row: 2;
  }
}
</style>
